/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Task } from 'ember-concurrency';
import { filterBy, equal } from '@ember/object/computed';

import ActionModel from 'cio/models/action';
import EventModel from 'cio/models/event';
import { IdentifierKey } from 'cio/utils/identifiers';
import { DataIndexSegment } from 'cio/utils/data-index';

interface SegmentsArgs {
  item: ActionModel | EventModel;
  createSegmentTask: Task<unknown, []>;
}

export default class Segments extends Component<SegmentsArgs> {
  @equal('args.item.type', 'attribute') showSegmentConditions!: boolean;
  @filterBy('args.item.segments', 'archived', false) activeSegments!: DataIndexSegment[];
  @filterBy('args.item.segments', 'archived', true) archivedSegments!: DataIndexSegment[];

  get canCreateSement() {
    let invalidAttributes: string[] = [IdentifierKey.CioId];

    return !invalidAttributes.includes(this.args.item.id);
  }
}
